var upsellSlickOptions = {
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow : '<button type="button" class="previous general">Previous <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.875112 9.13636L4.10826e-07 9.99747L0.875112 10.8586L8.782 18.6389L9.65712 19.5L11.4022 17.7829L10.5271 16.9218L4.73075 11.2131L21.7645 11.2131H23V8.78179H21.7645L4.73075 8.78179L10.5322 3.07825L11.4073 2.21714L9.66226 0.5L8.78715 1.3611L0.875112 9.13636Z" fill="#333333"/></svg></button>',
  nextArrow : '<button type="button" class="next general">Next <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.1249 11.4091L23 10.5027L22.1249 9.59624L14.218 1.40642L13.3429 0.5L11.5978 2.30752L12.4729 3.21394L18.2692 9.22301H1.23545H0V11.7823H1.23545H18.2692L12.4678 17.7861L11.5927 18.6925L13.3377 20.5L14.2128 19.5936L22.1249 11.4091Z" fill="#333333"/></svg></button>',
  responsive: [
    {
      breakpoint: 1401,
      settings: { slidesToShow: 1 }
    },
    {
      breakpoint: 960,
      settings: { slidesToShow: 1 }
    }
  ]
};

function initUpsellSlider() {
  var $carousel = $('.cart-drawer-container-new .cart-drawer-inner .cart-drawer-upsells .collection-grid__wrapper .collection-grid-new');
  var $wrapper = $('.cart-drawer-container-new .cart-drawer-inner .cart-drawer-upsells .collection-grid__wrapper');

  $wrapper.removeClass('slider-ready');

  if ($carousel.hasClass('slick-initialized')) {
    $carousel.slick('destroy');
  }

  $carousel.slick(upsellSlickOptions);

  if ($carousel.find('.cart-hidden').length) {
    $carousel.slick('slickFilter', ':not(.cart-hidden)');
  }

  // Short delay before fading in so slick has fully painted
  setTimeout(function() {
    $wrapper.addClass('slider-ready');
  }, 500);
}

function refreshUpsellSliderPosition() {
  var $carousel = $('.cart-drawer-container-new .cart-drawer-inner .cart-drawer-upsells .collection-grid__wrapper .collection-grid-new');
  if ($carousel.hasClass('slick-initialized')) {
    $carousel.slick('setPosition');
  }
}

$(document).ready(function(){

  // The upsell slider lives inside .drawer__inner, which is display:none
  // while the drawer has the .is-empty class. Slick can end up measuring/
  // filtering that container while it's still hidden (0 width) if an item
  // is re-added before the async cart rebuild removes .is-empty, baking in
  // broken slide widths that never self-correct. Recalculate the moment
  // .is-empty actually clears.
  var cartDrawerEl = document.getElementById('CartDrawer');
  if (cartDrawerEl) {
    var wasEmpty = cartDrawerEl.classList.contains('is-empty');
    var upsellObserver = new MutationObserver(function() {
      var isEmpty = cartDrawerEl.classList.contains('is-empty');
      if (wasEmpty && !isEmpty) {
        requestAnimationFrame(refreshUpsellSliderPosition);
      }
      wasEmpty = isEmpty;
    });
    upsellObserver.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  $('body').on('click', '.cart-drawer-container-new .drawer__close-button', function(e){
    e.preventDefault();
    $('.cart-drawer-container-new').fadeOut();
    $('html').removeClass('drawer-open-new');

    // Reset slider visibility so next open starts clean
    $('.cart-drawer-container-new .cart-drawer-inner .cart-drawer-upsells .collection-grid__wrapper').removeClass('slider-ready');
  });

  document.addEventListener('drawerOpen.CartDrawer', function() {
    var scrollY = window.scrollY;
    document.body.style.top = '-' + scrollY + 'px';
    $('.cart-drawer-container-new').fadeIn();
    $('html').addClass('drawer-open-new');

    $('.cart-drawer-container-new .cart-drawer-inner .cart-drawer-upsells, .cart-drawer-container-new .cart-drawer-inner div#CartDrawer')
        .css('visibility', 'visible')
        .animate({ opacity: 1 }, 400, function() {
          // Drawer is now fully painted at its final size. Slick may have measured
          // the wrong (mid-animation) width when it initialized, so force it to
          // recalculate slide widths against the real, settled layout.
          refreshUpsellSliderPosition();
        });

    setTimeout(function() {
      initUpsellSlider();
    }, 350);
  });

});

function refreshCartDrawer(event) {
  console.log('Product added:', event);

  let productId = event.detail.product.product_id;

  if (productId) {
    let $carousel = $('.cart-drawer-container-new .cart-drawer-inner .cart-drawer-upsells .collection-grid__wrapper .collection-grid-new');
    let $slide = $carousel.find('.product-slide-element.product-id-is-' + productId);

    if ($slide.length) {
      $slide.addClass('cart-hidden');
      $carousel.slick('slickUnfilter');
      $carousel.slick('slickFilter', ':not(.cart-hidden)');
      console.log('Hiding upsell for product:', productId);
    }
  }
}

document.addEventListener('ajaxProduct:added', refreshCartDrawer);

// Both removal paths (the explicit "Remove" link in cart-drawer.liquid and the
// qty stepper going to 0 via theme.CartForm) dispatch ajaxProduct:removed with
// the fresh cart payload. Refresh the subtotal from that directly instead of
// relying on cart-drawer.liquid's manual DOM patch, which was leaving the
// drawer's subtotal stale.
function updateCartDrawerSubtotal(event) {
  var cart = event.detail && event.detail.cart;

  if (!cart) {
    return;
  }

  var $subtotal = $('.cart-drawer-container-new [data-subtotal] .money');

  if ($subtotal.length) {
    $subtotal.html(theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat));
  }
}

document.addEventListener('ajaxProduct:removed', updateCartDrawerSubtotal);

/* Cart drawer empty state: Recently Viewed / Recommended discover carousel.
   Reuses theme.recentlyViewed (already populated site-wide on every PDP view).
   Cards are built to match the non-quick-add branch of the real product card
   (custom-product-card2-for-collection.liquid, quick_shop_enable_cart: false)
   — image-mask, grid-product__options with a plain size list, grid-product__meta
   — so the existing .uniform-q hover-reveal CSS works on them unmodified.
   theme.buildProductGridItem() was tried first but only outputs image/title/price
   with no options container at all, so it can't be used here. */
(function() {
  var initialized = false;
  var CARD_WIDTH = 171;
  var CARD_GAP = 16;

  function getContainer() {
    return document.querySelector('[data-cart-discover]');
  }

  function getRecentHandles() {
    if (!window.theme || !theme.recentlyViewed || !theme.recentlyViewed.recent) {
      return [];
    }
    return Object.keys(theme.recentlyViewed.recent)
        .filter(function(handle) { return handle && handle !== 'undefined'; })
        .reverse();
  }

  function fetchProduct(handle) {
    theme.recentlyViewed.productInfo = theme.recentlyViewed.productInfo || {};

    if (theme.recentlyViewed.productInfo[handle]) {
      return Promise.resolve(theme.recentlyViewed.productInfo[handle]);
    }

    return fetch('/products/' + handle + '.js')
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(product) {
          if (product) {
            theme.recentlyViewed.productInfo[handle] = product;
          }
          return product;
        })
        .catch(function() { return null; });
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : value;
    return div.innerHTML;
  }

  function buildSizeOptions(product) {
    return (product.variants || [])
        .map(function(variant) {
          if (variant.available) {
            return (
                '<li class="size">' +
                '<button type="button" data-variant-id="' + variant.id + '" data-available="true" aria-label="Add ' + escapeHtml(variant.option1) + ' to cart">' +
                escapeHtml(variant.option1) +
                '</button>' +
                '</li>'
            );
          }

          return (
              '<li class="size is--sold-out">' +
              '<a href="' + product.url + '?variant=' + variant.id + '&sold_out" aria-label="' + escapeHtml(variant.option1) + ' - Sold Out">' +
              escapeHtml(variant.option1) +
              '<div class="icon">' +
              '<svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M7.81587 6.8141L6.89977 5.72966C6.82076 5.63627 6.77839 5.51992 6.78068 5.40092V4.05604C6.80015 3.46366 6.61692 2.88034 6.25793 2.39089C5.89894 1.90151 5.38305 1.53059 4.78352 1.33207C4.9072 1.18957 4.97533 1.01185 4.9759 0.828272C4.9759 0.370902 4.57798 0 4.08729 0C3.59659 0 3.19867 0.370902 3.19867 0.828272C3.20096 1.00652 3.26394 1.17997 3.37732 1.32353C2.76812 1.51458 2.24078 1.8839 1.87374 2.37594C1.50673 2.868 1.31892 3.45718 1.33897 4.05599V5.33682C1.34183 5.4777 1.28229 5.61379 1.17407 5.71253L0.303778 6.51092C0.120558 6.6817 0.0129125 6.91012 0.00146496 7.15134V7.48863C-0.0134213 7.74853 0.0856318 8.0031 0.276295 8.19308C0.438335 8.35266 0.663344 8.44337 0.899243 8.44499H2.37878C2.48585 9.21562 3.18952 9.792 4.02322 9.792C4.85691 9.792 5.56051 9.21562 5.66765 8.44499H7.14719C7.39913 8.43858 7.63788 8.33825 7.80964 8.1664C7.98199 7.99456 8.07303 7.76614 8.06329 7.53133V7.40324C8.05528 7.18657 7.96817 6.97847 7.81587 6.8141ZM4.10574 0.409935C4.2798 0.409935 4.43668 0.507598 4.50366 0.657563C4.57008 0.807533 4.53344 0.980442 4.41034 1.09518C4.28724 1.20991 4.10172 1.24407 3.94084 1.18217C3.77994 1.11973 3.67517 0.973504 3.67517 0.811265C3.6849 0.596195 3.875 0.427015 4.10574 0.427015L4.10574 0.409935ZM4.00497 9.35869C3.42497 9.35869 2.92569 8.9755 2.81404 8.44503H5.1959C5.08425 8.9755 4.58497 9.35869 4.00497 9.35869ZM7.56852 7.53137C7.57883 7.65305 7.53589 7.77312 7.44943 7.86438C7.36298 7.95618 7.24102 8.01168 7.11047 8.01808H0.880994C0.771062 8.01702 0.666861 7.97379 0.592416 7.89854C0.488782 7.79287 0.434392 7.65304 0.441266 7.51001V7.177C0.443556 7.04304 0.503104 6.91549 0.606164 6.82263L1.49019 6.03279C1.68945 5.8524 1.79995 5.60424 1.79709 5.34541V4.06458C1.79709 2.74105 2.81397 1.66522 4.05994 1.66522C5.3059 1.66522 6.32277 2.74112 6.32277 4.06458V5.40946C6.32163 5.62293 6.39778 5.83053 6.53807 5.99864L7.45417 7.08308C7.52974 7.17808 7.56982 7.29336 7.56868 7.41182L7.56852 7.53137Z" fill="black" fill-opacity="1"/>' +
              '</svg>' +
              '</div>' +
              '</a>' +
              '</li>'
          );
        })
        .join('');
  }

  function buildDiscoverCard(product) {
    var price = product.variants && product.variants.length ? product.variants[0].price : product.price;

    return (
        '<div class="grid__item grid-product" data-aos="row-of-3">' +
        '<div class="grid-product__content">' +
        '<div class="grid-product__image-mask">' +
        '<a href="' + product.url + '" class="grid-product__link">' +
        (product.images && product.images[1] ?
            '<div class="image-wrap secondary-image-wrapper"><img loading="lazy" src="' + product.images[1] + '" alt="' + escapeHtml(product.title) + '"></div>' :
            '') +
        '<div class="image-wrap main-image-wrapper"><img loading="lazy" src="' + product.featured_image + '" alt="' + escapeHtml(product.title) + '"></div>' +
        (product.images && product.images[2] ?
            '<div class="image-wrap tertiary-image-wrapper"><img loading="lazy" src="' + product.images[2] + '"></div>' :
            '') +
        (product.images && product.images[3] ?
            '<div class="image-wrap quaternary-image-wrapper"><img loading="lazy" src="' + product.images[3] + '"></div>' :
            '') +
        '</a>' +
        '<button type="button" class="quick-buy-button">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M10.0137 0V19.25" stroke="black" stroke-width="0.75"/>' +
        '<path d="M0.388672 9.625H19.6387" stroke="black" stroke-width="0.75"/>' +
        '</svg>' +
        '</button>' +
        '<div class="quick-buy-purchasing">' +
        '<ul class="option size-options">' +
        buildSizeOptions(product) +
        '</ul>' +
        '</div>' +
        '</div>' +
        '<div class="grid-product__meta">' +
        '<a href="' + product.url + '" class="grid-product__link">' +
        '<div class="grid-product__title">' + escapeHtml(product.title) + '</div>' +
        '<div style="display: flex; gap: 10px; align-items: center;" class="prices-container"><div class="grid-product__price">' + theme.Currency.formatMoney(price, theme.settings.moneyFormat) + '</div></div>' +
        '</a>' +
        '</div>' +
        '</div>' +
        '</div>'
    );
  }

  function renderCards(track, products) {
    if (!products.length) return false;
    track.innerHTML = products.map(buildDiscoverCard).join('');
    return true;
  }

  function activateTab(container, key) {
    container.querySelectorAll('[data-discover-tab]').forEach(function(btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-discover-tab') === key);
    });
    container.querySelectorAll('[data-discover-panel]').forEach(function(panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-discover-panel') === key);
    });
    resetCarousel(container.querySelector('[data-discover-panel].is-active [data-discover-track]'));
  }

  function resetCarousel(track) {
    if (!track) return;
    track.scrollLeft = 0;
    updateArrows(track);
  }

  function updateArrows(track) {
    var container = track.closest('[data-cart-discover]');
    var prevBtn = container.querySelector('[data-discover-prev]');
    var nextBtn = container.querySelector('[data-discover-next]');
    var maxScroll = track.scrollWidth - track.clientWidth;

    prevBtn.disabled = track.scrollLeft <= 0;
    nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
  }

  function shiftTrack(container, direction) {
    var track = container.querySelector('[data-discover-panel].is-active [data-discover-track]');
    if (!track) return;

    var step = CARD_WIDTH + CARD_GAP;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function loadRecentlyViewed(container) {
    var tab = container.querySelector('[data-discover-tab="recently-viewed"]');
    var panel = container.querySelector('[data-discover-panel="recently-viewed"]');
    var track = panel.querySelector('[data-discover-track]');
    var handles = getRecentHandles().slice(0, 6);

    if (!handles.length) {
      tab.classList.add('is-unavailable');
      activateTab(container, 'recommended');
      return Promise.resolve([]);
    }

    return Promise.all(handles.map(fetchProduct)).then(function(products) {
      products = products.filter(Boolean);

      if (!renderCards(track, products)) {
        tab.classList.add('is-unavailable');
        activateTab(container, 'recommended');
      }

      return products;
    });
  }

  function initCarouselControls(container) {
    container.querySelector('[data-discover-prev]').addEventListener('click', function() {
      shiftTrack(container, -1);
    });
    container.querySelector('[data-discover-next]').addEventListener('click', function() {
      shiftTrack(container, 1);
    });
    container.querySelectorAll('[data-discover-tab]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.classList.contains('is-unavailable')) return;
        activateTab(container, btn.getAttribute('data-discover-tab'));
      });
    });

    // Native scroll (touch swipe, trackpad, drag) doesn't bubble, so each
    // track needs its own listener to keep the arrow disabled states in sync.
    container.querySelectorAll('[data-discover-track]').forEach(function(track) {
      track.addEventListener('scroll', function() {
        updateArrows(track);
      });
    });
  }

  function initDiscoverIfEmpty() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer || !cartDrawer.classList.contains('is-empty')) return;

    var container = getContainer();
    if (!container) return;

    if (!initialized) {
      initialized = true;
      initCarouselControls(container);
    }

    loadRecentlyViewed(container).then(function() {
      resetCarousel(container.querySelector('[data-discover-panel].is-active [data-discover-track]'));
    });
  }

  document.addEventListener('drawerOpen.CartDrawer', initDiscoverIfEmpty);

  // The drawer can also become empty while it's already open (last item
  // removed via the qty stepper or the "Remove" link), which doesn't
  // re-fire drawerOpen.CartDrawer. Without this, the discover carousel's
  // tabs/arrows never get their click handlers bound and "Recently Viewed"
  // never gets populated, even though the empty-state markup is now visible.
  $(function() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    var wasEmpty = cartDrawer.classList.contains('is-empty');
    var emptyStateObserver = new MutationObserver(function() {
      var isEmpty = cartDrawer.classList.contains('is-empty');
      if (!wasEmpty && isEmpty) {
        initDiscoverIfEmpty();
      }
      wasEmpty = isEmpty;
    });
    emptyStateObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  });
})();